import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { EditFlowState } from '../models/flows.model';
import * as selectors from '../selectors/edit-flow.selectors';
import { distinctUntilChanged } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EditFlowFacadeService extends FacadeService {
  constructor(public override store: Store<EditFlowState>) {
    super(store);
  }

  // OBSERVABLES
  isCreate$ = this.storeSelect(selectors.getIsCreate);
  isEdit$ = this.storeSelect(selectors.getIsEdit);
  languages$ = this.storeSelect(selectors.getLanguages);
  flowName$ = this.storeSelect(selectors.getFlowName);
  flowContextValues$ = this.storeSelect(selectors.getContextValues);
  flowContext$ = this.storeSelect(selectors.getContext);
  activeFlows$ = this.storeSelect(selectors.getActiveFlows);
  flowNameValidation$ = this.storeSelect(selectors.getFlowNameValidation);
  flowContextValidation$ = this.storeSelect(selectors.getFlowContextValidation);
  jsonData$ = this.storeSelect(selectors.getJsonData);
  jsonDataParsed$ = this.storeSelect(selectors.getJsonDataParsed);
  jsonDataId$ = this.storeSelect(selectors.getJsonDataId);
  clearJsonData$ = this.storeSelect(selectors.getClearJsonData);
  validate$ = this.storeSelect(selectors.getValidate);
  invalidJSON$ = this.storeSelect(selectors.getInvalidJSON);
  flowEqualityValidation$ = this.storeSelect(selectors.getFlowEqualityValidation);
  missingStartValidation$ = this.storeSelect(selectors.getMissingStartValidation);
  allValidations$ = this.storeSelect(selectors.getAllValidations);
  canViewJSONRoles$ = this.storeSelect(selectors.getCanViewJSONRoles);
  canViewJSONOnly$ = this.storeSelect(selectors.getCanViewJSONOnly);
  updateRole$ = this.storeSelect(selectors.getUpdateRole);
  updateAdvancedRole$ = this.storeSelect(selectors.getUpdateAdvancedRole);
  flowNamesValidation$ = this.storeSelect(selectors.getFlowNamesValidation);
  jsonValid$ = this.storeSelect(selectors.getJSONValid);

  // OBSERVABLE'S VALUES
  get isCreate() {
    return this.storeSnapshot(this.isCreate$);
  }

  get flowName() {
    return this.storeSnapshot(this.flowName$);
  }

  get flowContext() {
    return this.storeSnapshot(this.flowContext$);
  }

  get activeFlows() {
    return this.storeSnapshot(this.activeFlows$);
  }

  get jsonData() {
    return this.storeSnapshot(this.jsonData$);
  }

  get jsonDataParsed() {
    return this.storeSnapshot(this.jsonDataParsed$);
  }

  get jsonDataId() {
    return this.storeSnapshot(this.jsonDataId$);
  }

  get validate() {
    return this.storeSnapshot(this.validate$);
  }

  get flowEqualityValidation() {
    return this.storeSnapshot(this.flowEqualityValidation$);
  }

  get missingStartValidation() {
    return this.storeSnapshot(this.missingStartValidation$);
  }

  get allValidations() {
    return this.storeSnapshot(this.allValidations$);
  }

  get updateRole() {
    return this.storeSnapshot(this.updateRole$);
  }

  get invalidJSON() {
    return this.storeSnapshot(this.invalidJSON$);
  }

  get flowNamesValidation() {
    return this.storeSnapshot(this.flowNamesValidation$);
  }

  get jsonValid() {
    return this.storeSnapshot(this.jsonValid$);
  }
}
